(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('ProfileCriterionSearch', ProfileCriterionSearch);

    ProfileCriterionSearch.$inject = ['$resource'];

    function ProfileCriterionSearch($resource) {
        var resourceUrl =  'api/_search/profile-criteria/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
